import { FC } from 'react'
import { SearchItem } from 'hooks/useArrowsNavigation'
import { CustomEmoji } from 'components/emojis/emojisSlice'
import { cn, Tooltip, TooltipTrigger, TooltipContent } from '@wellesley/ui'

import getTextWithHighlight from './helpers/getTextWithHighlight'

type TAutocompleteRow = SearchItem &
  Partial<CustomEmoji> & {
    partHash: string
    isSelected: boolean
    onSelectTag(tag: string): void
  }

const AutocompleteRow: FC<TAutocompleteRow> = ({
  img,
  name,
  emoji,
  emojiUrl,
  partHash,
  isSelected,
  displayName,
  onSelectTag,
}) => {
  return (
    <div
      data-testid="autocomplete-row"
      onClick={() => name && onSelectTag(name)}
      className={cn(
        'pointer-events-auto flex cursor-pointer flex-row items-center rounded-[6px] px-[16px] py-[8px] leading-[18px] hover:bg-gray-50',
        isSelected ? 'bg-gray-100' : '',
        partHash[0] === '@' ? 'min-h-[55px]' : 'min-h-[34px]',
      )}
    >
      {img && img}
      {emoji && emoji}
      {emojiUrl && <img className="custom-emoji" src={emojiUrl} alt={name} />}
      <div className="ml-2.5 flex flex-col text-sm">
        {displayName && (
          <Tooltip disableHoverableContent>
            <TooltipTrigger>
              <p
                className="max-w-[190px] overflow-hidden text-ellipsis whitespace-nowrap text-start font-semibold text-gray-700"
                dangerouslySetInnerHTML={{
                  __html: getTextWithHighlight(partHash, displayName, false),
                }}
              />
            </TooltipTrigger>
            <TooltipContent theme="dark" size="small">
              {displayName}
            </TooltipContent>
          </Tooltip>
        )}
        <Tooltip disableHoverableContent>
          <TooltipTrigger>
            <p
              className="max-w-[190px] overflow-hidden text-ellipsis text-start font-medium"
              dangerouslySetInnerHTML={{
                __html: getTextWithHighlight(partHash, name || ''),
              }}
            />
          </TooltipTrigger>
          <TooltipContent theme="dark" size="small">
            {name}
          </TooltipContent>
        </Tooltip>
      </div>
    </div>
  )
}

export default AutocompleteRow
